import React from 'react'
import location from '../../../api/location'

export default function ImageMaterial(props) {
  const { material } = props

  const url = location.backendURL() + material.content

  return <img alt={material.title} src={url} style={{ width: '100%' }} />
}